import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class StaffInstrutores extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      dados: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.loadData = this.loadData.bind(this);
  }

  // Handlers
  handleAlert(message, type, status) {
    this.setState({overlay: {message: message, type: type, status: status}});
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }
  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/alunos/instrutores', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        self.setState({status_loading: 2});
        if (responseJson.status === 'success') {
          self.setState({dados: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  botaoEdicao (cell, row) {
    var url = '/aluno/editar/' + cell;

    var botao = (
      <Link className={'btn btn-primary btn-sm'} to={url}>
        <i className="fa fa-fw fa-pencil"></i>
      </Link>
    );

    return botao;
  }


  botaoName (cell, row) {
    var url = '/aluno/editar/' + row.id;
    var botao = (
      <Link to={url}>
        <strong>{row.camel_name}</strong>
      </Link>
    );

    return botao;
  }


  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Lista de instrutores</h3>
      <Link to="/aluno/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> Adicionar Aluno</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há alunos cadastrados', sizePerPage: 100, defaultSortName: 'camel_name', defaultSortOrder: 'ASC'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="camel_name" dataFormat={this.botaoName} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width='500'>Nome</TableHeaderColumn>

        <TableHeaderColumn dataField="canac" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>CANAC</TableHeaderColumn>

        <TableHeaderColumn dataField="celular_1" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Celular 1</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoEdicao} width='80'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default StaffInstrutores;



// WEBPACK FOOTER //
// ./src/Components/Staffs/StaffsInstrutores.js